export interface VehicleStatusCount {
  statusName: string | null;
  count: number;
}

export type StatusTone = 'amber' | 'orange' | 'rose' | 'slate' | 'blue' | 'teal' | 'violet';

export interface StatusSlice {
  key: string;
  label: string | null;
  count: number;
  tone: StatusTone;
}

const TONE_BY_NAME: Record<string, StatusTone> = {
  'leasing förfaller': 'amber',
  'under avveckling': 'orange',
  'ej i bruk': 'rose',
};

const EXTRA_TONES: StatusTone[] = ['blue', 'teal', 'violet'];

/** Namngivna statusar först, ingen status sist. Kända namn får färgen från skissen. */
export function statusSlices(rows: VehicleStatusCount[]): StatusSlice[] {
  let extra = 0;
  const named = rows.filter((row) => row.statusName != null);
  const missing = rows.filter((row) => row.statusName == null);
  return [...named, ...missing].map((row) => {
    if (row.statusName == null) {
      return { key: 'none', label: null, count: row.count, tone: 'slate' };
    }
    const known = TONE_BY_NAME[row.statusName.trim().toLowerCase()];
    const tone = known ?? EXTRA_TONES[extra++ % EXTRA_TONES.length];
    return { key: row.statusName, label: row.statusName, count: row.count, tone };
  });
}
